import axios, { AxiosError } from 'axios'
import { Either, left, right } from 'fp-ts/Either'

export interface FormData {
  name: string
  lastname: string
  email: string
  phone?: string
  nationality?: string
  message?: string
  arrival: string
  departure: string
  adults: string
  children?: string
  ages?: string
  offer_title?: string
  room_title?: string
  privacy_policy: boolean
}

export interface QuotationFormSenderBackendConfiguration {
  formURL: string
}

export type QuotationFormSenderBackend = (
  data: FormData,
) => Promise<Either<AxiosError, void>>

export const QuotationFormSenderBackend =
  ({
    formURL,
  }: QuotationFormSenderBackendConfiguration): QuotationFormSenderBackend =>
  async (data): Promise<Either<AxiosError, void>> => {
    try {
      await axios({
        method: 'POST',
        url: formURL,
        headers: {
          'Content-type': 'application/json',
        },
        data,
      })
      return right(undefined)
    } catch (error) {
      return left(error as any)
    }
  }
